import {Tag} from '@vio/atlas/src/components/designSystem/Tag'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

export const RoomOfferSelectedLabel = () => {
  return (
    <Tag variant="success" dataId="selectedRoomOfferLabel">
      <FormattedMessageWrapper
        id="yourSelection"
        defaultMessage="Your selection"
      />
    </Tag>
  )
}
